// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"09bcf5fb","366":"a13b52d3","860":"d0f14382"}[chunkId] + ".chunk.css";
};